<template>
  <div class="mx-auto flex max-w-7xl flex-col items-center gap-6 bg-white px-4 py-8 sm:flex-row sm:justify-center sm:gap-10 sm:px-6 lg:px-8">
    <slot />
  </div>
</template>
